module.exports = __webpack_public_path__ + "img/polygon.0c343e8d.png";